import React from 'react';
import { useParams } from 'react-router-dom';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import VendorStoreMachineList from './VendorStoreMachineList';

const VendorStoreMachine = () => {
    const { storeNo } = useParams();

    // 매장 기기(키오스크 1대, 기계 2대로 가정)
    const storeMachineData = [
        {
            storeId: storeNo,
            storeName: '관저점 ' + storeNo,
            storeMachineId: 'M_20240328_01',
            storeMachineType: 'kiosk',
            storeMachineStatus: 'online',
        },
        {
            storeId: storeNo,
            storeName: '관저점 ' + storeNo,
            storeMachineId: 'M_20240328_02',
            storeMachineType: 'vending',
            storeMachineStatus: 'offline',
        },
        {
            storeId: storeNo,
            storeName: '관저점 ' + storeNo,
            storeMachineId: 'M_20240328_03',
            storeMachineType: 'vending',
            storeMachineStatus: 'error',
        },
    ];

    return (
        <VerticalFlex gap="1rem">
            {/* <div>VendorStoreMachine storeId : {storeNo}</div> */}
            {storeMachineData.map((machine, index) => (
                <VendorStoreMachineList key={index} machine={machine} />
            ))}
        </VerticalFlex>
    );
};

export default VendorStoreMachine;
